export const ON_SIMPLE_VALUE_CHANGED = `dialogs@ON_SIMPLE_VALUE_CHANGED`



// WEBPACK FOOTER //
// ./src/store/simpleValues/types.js